/** ใช้กับเมนู drawer — active ตาม path (รองรับ client-side navigation) */
export function navPathMatchesItem(pathname: string, url: string | undefined): boolean {
  if (!url || !pathname) return false;
  if (pathname.includes('product-details') && url.includes('product-details')) return true;
  if (pathname.includes('kanban') && url.includes('kanban')) return true;
  if (url === '/') return pathname === '/' || pathname === '';
  return pathname === url || pathname.startsWith(`${url}/`);
}
